import React from 'react';
import type { VanLifeState, VanLifeAction } from '../../../../games/van-life/van-life';
import { ZONE_CARDS, CHALLENGE_CARDS } from '../../../../games/van-life/van-life';

interface Props {
  state: VanLifeState;
  myId: string;
  movableParkIds: string[];
  dispatch: (action: VanLifeAction) => void;
}

export default function MovementPanel({ state, myId, movableParkIds, dispatch }: Props) {
  const me = state.players.find(p => p.id === myId)!;
  const partner = state.players.find(p => p.id !== myId)!;

  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-lg font-bold text-amber-200">
        Movement — Match {state.matchNumber}
      </h2>

      {state.pendingMoves[myId] !== undefined ? (
        <div className="rounded-lg bg-gray-900 border border-gray-700 p-4 text-center">
          <p className="text-green-400 font-semibold">
            Moving to: {state.parks.find(p => p.id === state.pendingMoves[myId])?.name}
          </p>
          <p className="text-gray-500 text-sm mt-1">Waiting for {partner?.name}…</p>
        </div>
      ) : (
        <div className="rounded-lg bg-gray-900 border border-amber-800 p-4">
          <p className="text-amber-300 text-sm mb-3">
            Click a highlighted park on the map, or choose below:
          </p>
          <div className="grid grid-cols-2 gap-2">
            {movableParkIds.map(parkId => {
              const park = state.parks.find(p => p.id === parkId)!;
              const zone = ZONE_CARDS.find(z => z.id === park.zoneCardId)!;
              const challenge = CHALLENGE_CARDS.find(c => c.id === park.challengeCardId)!;
              return (
                <button key={parkId}
                  onClick={() => dispatch({ type: 'chooseMove', playerId: myId, targetParkId: parkId })}
                  className="text-left rounded-lg border border-amber-700 bg-amber-950/20 p-3
                    hover:bg-amber-900/30 hover:border-amber-500 transition-colors">
                  <div className="font-semibold text-amber-200 text-sm">
                    {park.name}
                    {parkId === me.currentParkId && <span className="ml-1 text-gray-500 text-xs">(stay)</span>}
                    {park.conquered && <span className="ml-1 text-yellow-400">★</span>}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">Zone: {zone.name}</div>
                  <div className="text-xs text-gray-400">Challenge: {challenge.name}</div>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Partner's move status */}
      <div className="text-sm text-gray-600">
        {partner?.name}: {state.pendingMoves[partner?.id] !== undefined
          ? `moving to ${state.parks.find(p => p.id === state.pendingMoves[partner?.id])?.name}`
          : 'choosing…'}
      </div>
    </div>
  );
}
